import { SkyGoogleTagConfig } from '@sky/util-models';

export const gaTagsConfig: SkyGoogleTagConfig = {
  checkoutSteps: {
    checkoutLanding: 1,
    personalDetails: 2,
    selectPayment: null,
    paymentDetails: 3,
    quote: null,
    loggedIn: null,
    paymentDetailsSummary: null,
  },
  dimensions: {
    brandName: null,
    paymentType: null,
    companyCode: null,
    applianceName: null,
    applianceDetailsValues: null,
    excess: null,
    reference: null,
    coverType: null,
    paymentNumber: null,
    fee: null,
    schemeCode: null,
    purchaseMonth: 'dimension35',
    purchaseYear: 'dimension36',
    purchasePrice: 'metric4',
    lt: 'dimension34',
    ltPrice: 'metric3',
  },
  config: {
    showLegacyTags: false,
  },
  quoteLandingTags: {
    event: 'app.pageView',
    pagename: 'sky-box-selection',
    genericpagename: 'sky-box-selection',
    category: 'sky-mobile',
  },
  selectSkyBoxCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'SkyBoxSelectButton',
  },
  applianceDetailsLandingTags: {
    event: 'app.pageView',
    pagename: 'add-device-page',
    genericpagename: 'sky-mobile-multiplan-builder',
    category: 'sky-mobile',
  },
  inclusionExclusionsData: {
    event: 'GAEvent',
    eventname: 'quote-tab',
    eventCategory: 'quote-summary',
    eventAction: 'quote tab clicked',
  },
  selectDeviceCategory: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
  },
  addItemToBasket: {
    event: 'productAdd',
  },
  addDeviceCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
  },
  addLaterCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
    eventAction: 'DeviceDetails',
    eventLabel: 'Add later',
  },
  deleteItemFromBasket: {
    event: 'EEremoveFromCart',
  },
  basketLandingTags: {
    event: 'app.pageView',
    pagename: 'check-out-summary',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
  },
  productCheckoutData: {
    event: 'productCheckout',
  },
  checkoutSummaryCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'CheckoutSummary',
    eventAction: 'Continue to Payment',
  },
  checkoutPersonalDetails: {
    event: 'app.pageView',
    pagename: 'personal-detail-page',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
  },
  checkoutDirectDebitCommonData: {
    event: 'app.pageView',
    pagename: 'sky-mobile-payment',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
    EmailAddress: 'provided',
  },
  onOrderConfirmationPageLoad: {
    event: 'app.pageView',
    pagename: 'sky-mobile-order-confirmation',
    genericpagename: 'order-confirmation',
    category: 'sky-mobile',
  },
  orderConfirmationTaggingData: {
    event: 'EEtransaction',
  },
};
